import {FunnelOrder, FunnelReentryModeType} from 'common/types/reports/bookmark';
import {ConversionWindow, CountType} from 'common/report/funnels/models/types';
import {Segmentation} from 'common/types/reports/query';

import {QueryEventEntry, RowLabelType} from '../query-entry-section/types';

export type BuilderParams = {
  entriesCount: number;
  exclusionSteps: QueryEventEntry[];
  dataGroupsEnabled: boolean | undefined;
  dataGroupId: string | undefined;
  projectHasPeople: boolean;
  projectHasCohorts: boolean;
  projectId: number | undefined;
  workspaceId: number | undefined;
  trackName: string | undefined;
  projectAsOfDate: string | null | undefined;
  entryRowLabelType: RowLabelType;
};

export type SelectedQueryOptions = {
  countType: CountType;
  holdingPropertyConstant: Segmentation[] | undefined;
  funnelOrder: FunnelOrder | undefined;
  conversionWindow: ConversionWindow;
  funnelReentryMode: FunnelReentryModeType;
};

// TODO: a bit awkward that this component takes in exclusionSteps seperately via QueryBuilderAtttrs,
// yet emits them along with SelectedQueryOptions
export type QueryOptionsSelection = SelectedQueryOptions & {exclusionSteps?: QueryEventEntry[]};

export type QueryOptionsProps = {
  builderParams: BuilderParams;
  conversionWindowUnits: string[];
  conversionWindowSizeLimits: any;
  disableAnyOrderMessage?: string;
  enableStickyHeader: boolean;
  eventNames: string[];
  hideFunnelsOnlyOptions: boolean;
  hideConversionWindow: boolean;
  hideCountSelector?: boolean;
  maxHoldingPropertyConstant: number;
  onChangeQueryOption: (options: QueryOptionsSelection) => void;
  onTrack?: (data: any) => void;
  projectId: number | undefined;
  selected: SelectedQueryOptions;
  showSessions: boolean;
  workspaceId: number | undefined;
};

export interface QueryOptionsState {
  conversionWindowErrorMsg: null | string;
  isConversionWindowMenuOpen: boolean;
  isConversionWindowMenuHovered: boolean;
  isCountTypeMenuOpen: boolean;
  isCountTypeMenuHovered: boolean;
  selectedValue: number;
  selectedUnit: string;
  holdingPropertyConstant: Segmentation[];
  stageHoldProps: boolean;
  stageExclusionSteps: boolean;
}

export enum ConversionCriteriaAction {
  ExcludeEvent = `excludeEvent`,
  HoldProperty = `holdProperty`,
}
